// Financial privacy is independent of technical administrator access.
export const FINANCE_RESTRICTED_EMAILS = Object.freeze(['moyses.constantino@gmail.com'])
export function hasRestrictedFinance(email) {
  return FINANCE_RESTRICTED_EMAILS.includes(String(email || '').trim().toLowerCase())
}
